import { createAction } from "redux-act";

export const OpenEditNodeModalAction = createAction("Edit Node - Open Modal");
export const CloseEditNodeModalAction = createAction("Edit Node - Close Modal");
